module.exports = __webpack_public_path__ + "img/1654605815513164985963179220220408081800.39e2def7.4cb58355.jpg";